<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("suppliers/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
  computed: {
    supplier() {
          return this.$store.state.suppliers.supplier;
      }
  },
};
</script>